import { createRouter, createWebHistory } from 'vue-router'
import Login from '../../src/components/base/TheLogin'
import Logout from '../../src/components/pages/Logout'
import Home from '../../src/components/pages/Home'
import SettingPersonal from '../../src/components/pages/SettingPersonal'
import DeletedPersonal from '../../src/components/pages/DeletedPersonal'
import Signup from '../../src/components/pages/Signup'
import ResetPassword from '../../src/components/pages/ResetPassword'
import TopPage from '../components/pages/TopPage.vue'

import TermsJa from '../../src/terms/ja/Index'
import TermsEn from '../../src/terms/en/Index'

import SettingCustomer from '../../src/components/pages/SettingCustomer'
import ManageAccounts from '../../src/components/pages/ManageAccounts'
import DeletedManageAccounts from '../../src/components/pages/DeletedManageAccounts'
// import ManagePayments from '../../src/components/pages/ManagePayments'  // 現時点では見せない

// Services
import RemoteRack from '../../src/components/pages/Services/RemoteRack/RemoteRack'
import Repli from '../../src/components/pages/Services/Repli/Repli'
import RepliSellerPortal from '../../src/components/pages/Services/RepliSellerPortal/RepliSellerPortal'
import RepliCePortal from '../../src/components/pages/Services/RepliCePortal/RepliCePortal'
import RepliManagePortal from '../../src/components/pages/Services/RepliManagePortal/RepliManagePortal'
import NoUserService from '../../src/components/pages/Services/NonUserService/NonUserService'
import { isTokenExpired, updateAccessToken } from '../library/utils'

// Router定義 metaキー配列のtitleキーには、翻訳したいキーを入れる。これはタイトルバーに表示される。
const routes = [
  { path: '/terms/ja/', components: { always: TermsJa } },
  { path: '/terms/en/', components: { always: TermsEn } },

  { path: '/signup', name: 'Signup', components: { noSession: Signup } },
  { path: '/hdw3co8ue5x', name: 'ResetPassword', components: { noSession: ResetPassword } },
  { path: '/login',
    name: 'Login',
    components: {
      noSession: Login
    }
  },

  {
    path: '/:pathMatch(.*)*',
    name: 'Any',
    component: TopPage,
    meta: { title: 'Menu.Home' }
  },
  {
    path: '/',
    name: 'Home',
    component: TopPage,
    meta: { title: 'Menu.Home' },
    children: [
      { path: '/logout', name: 'Logout', component: Logout, meta: { title: 'User.Logout' } },
      {
        path: '',
        name: 'HomePage',
        component: Home,
        meta: { title: 'Menu.Home' }
      },
      {
        path: 'personal-settings',
        name: 'PersonalSettings',
        component: SettingPersonal,
        meta: { title: 'Menu.PersonalSettings' }
      },
      {
        path: '/customer-settings',
        name: 'CustomerSettings',
        component: SettingCustomer,
        meta: { title: 'Menu.CustomerSettings' }
      },
      {
        path: '/manage-accounts',
        name: 'ManageAccounts',
        component: ManageAccounts,
        meta: { title: 'Menu.ManageAccounts' },
        children: [
          { path: ':id', component: SettingPersonal, meta: { title: 'Menu.ManageAccounts' } }
        ]
      },
      {
        path: '/deleted-manage-accounts',
        name: 'DeletedManageAccounts',
        component: DeletedManageAccounts,
        meta: { title: 'Menu.DeletedManageAccounts' },
        children: [
          { path: ':id', component: DeletedPersonal, meta: { title: 'Menu.DeletedManageAccounts' } }
        ]
      },
      // {path: '/manage-payments', name: 'ManagePayments', component: ManagePayments, meta: {title: 'Menu.ManagePayments'}},  // 現時点では見せない
      // サービス
      { path: '/remoterack', name: 'remoterack', component: RemoteRack, meta: { title: 'Service.Brand.remoterack' } },
      { path: '/repli', name: 'repli', component: Repli, meta: { title: 'Service.Brand.repli' } },
      {
        path: '/repli_seller_portal',
        name: 'repli_seller_portal',
        component: RepliSellerPortal,
        meta: { title: 'Service.Brand.repli_seller_portal' }
      },
      {
        path: '/repli_ce_portal',
        name: 'repli_ce_portal',
        component: RepliCePortal,
        meta: { title: 'Service.Brand.repli_ce_portal' }
      },
      {
        path: '/repli_manage_portal',
        name: 'repli_manage_portal',
        component: RepliManagePortal,
        meta: { title: 'Service.Brand.repli_manage_portal' }
      },
      {
        path: '/moldiv',
        name: 'moldiv',
        component: NoUserService,
        props: { serviceId: 'moldiv' },
        meta: { title: 'Service.Brand.moldiv' }
      },
      {
        path: '/rudder',
        name: 'rudder',
        component: NoUserService,
        props: { serviceId: 'rudder' },
        meta: { title: 'Service.Brand.rudder' }
      }
    ]
  }
]

// vue-router設定
const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.matched.length &&
    'noSession' in to.matched[0].components || 'always' in to.matched[0].components) {
    next()
  } else if (token && isTokenExpired()) {
    // token is expired, try to update the access token
    updateAccessToken(next)
  } else if (token) {
    // token is not expired, go to the next page
    next()
  } else {
    // Tokenが存在しない(=セッションが存在しない)
    next({ path: '/login' })
  }
})

export default router
